import { render, staticRenderFns } from "./gerenxunLI.vue?vue&type=template&id=208872a9&"
import script from "./gerenxunLI.vue?vue&type=script&lang=js&"
export * from "./gerenxunLI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports